import React from "react";
import moment from "moment";

import Select from "react-select";

import { toast } from "react-toastify";

import { DropdownButton, MenuItem } from "react-bootstrap";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import {
  UNIFIED_PROJECT_STEPS,
  UNIFIED_PROJECT_STEP_ORDER,
  UNIFIED_PROJECT_FORECAST_STEP_ORDER
} from "containers/UnifiedProject/reducer";

import { LineInput } from "components/Inputs/LineInput";
import HeaderTabContainer from "containers/UnifiedProject/HeaderTab";
import CollaboratorsContainer from "containers/UnifiedProject/Collaborators/Collaborators";
import AuditContainer from "containers/UnifiedProject/Audit/Audit";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

export default class UnifiedProjectHeader extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editName: false
    };
  }

  componentWillUnmount() {
    const { updateIsAudit } = this.props;
    //updateIsAudit(false);
  }

  render() {
    const {
      id,
      label,
      blueprint,
      blueprintId,
      updateLabel,
      updateProjectName,
      updateProjectId,
      currentStep,
      createdDate,
      project,
      hasSplits,
      saveBlueprint,
      highlightStep,
      isAudit,
      history,
      isEditBlueprint,
      isSavingBlueprint,
      updateIsAudit,
      updateIsEditBlueprint,
      isForecast,
      optimized,
      datasetId,
      nextId
    } = this.props;

    const isSetup = id === "new";

    return (
      <div className={styles.headerWrapper} style={{ height: isAudit ? "calc(100% - 60px)" : "60px" }}>
        <div className={styles.headerLeftWrapper + " " + (isAudit ? styles.isAudit : "")}>
          <div className={styles.innerLeft}>
            {isEditBlueprint ? (
              <div
                className={
                  styles.headerInfoWrapper + " " + (hasSplits ? styles.hasSplits : "") + " " + styles.editBlueprintInfo
                }
                style={isSetup ? { flexBasis: "250px" } : {}}
              >
                {"Editing Blueprint"}
              </div>
            ) : (
              <div
                className={
                  styles.headerInfoWrapper +
                  " " +
                  (hasSplits ? styles.hasSplits : "") +
                  " " +
                  (this.state.editName ? "" : styles.cursorOverride)
                }
                style={isSetup ? { flexBasis: "250px" } : undefined}
                onClick={isSetup || this.state.editName ? undefined : () => this.setState({ editName: true })}
              >
                <LineInput
                  isShowEditable={isSetup}
                  isLocked={!isSetup && !this.state.editName}
                  isEditable={isSetup}
                  showRight
                  value={label}
                  onChange={(val) => {
                    if (isSetup) {
                      return updateLabel(val);
                    } else {
                      return updateProjectName(val).then(() => {
                        this.setState({ editName: false });
                      });
                    }
                  }}
                  style={{
                    width: "200px",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    display: "block",
                    minHeight: "18px"
                  }}
                />
                {!this.state.editName && createdDate ? (
                  <div className={styles.headerInfoDate}>
                    {moment.utc(createdDate).local().format("MMM Do YYYY, h:mm a")}
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
            {isForecast
              ? UNIFIED_PROJECT_FORECAST_STEP_ORDER.map((stepId, i) => (
                  <HeaderTabContainer id={id} stepId={stepId} key={i} highlightStep={highlightStep} />
                ))
              : UNIFIED_PROJECT_STEP_ORDER.map((stepId, i) => (
                  <HeaderTabContainer id={id} stepId={stepId} key={i} highlightStep={highlightStep} />
                ))}
          </div>
          {isAudit ? (
            <div className={styles.auditWrapper}>
              <AuditContainer id={id} />
            </div>
          ) : (
            <div />
          )}
        </div>
        <div className={styles.headerActionsWrapper + " " + (isEditBlueprint ? styles.disabledActions : "")}>
          {isForecast ? (
            <React.Fragment />
          ) : isSavingBlueprint ? (
            <LoadingIndicator style={{ margin: "0px", marginRight: "10px" }} />
          ) : (
            <DropdownButton pullRight id="blueprint-dropdown-button" title="" style={{ margin: "3px 10px 3px 20px" }}>
              <MenuItem onClick={() => updateIsEditBlueprint(true)}>
                {blueprint === undefined ? "Create New Blueprint" : "Edit Blueprint"}
              </MenuItem>
              {blueprint && (
                <MenuItem
                  onClick={() => {
                    toast("Blueprint copied to clipboard.", {
                      type: toast.TYPE.SUCCESS,
                      position: toast.POSITION.TOP_CENTER,
                      autoClose: 3500
                    });
                    navigator.clipboard.writeText(JSON.stringify(blueprint));
                  }}
                >
                  {"Export Blueprint"}
                </MenuItem>
              )}
              {isEnabled("audit") &&
                project &&
                project.settings &&
                project.settings.originalScenarios &&
                project.settings.originalScenarios.length > 0 && (
                  <MenuItem onClick={() => updateIsAudit(!isAudit)}>{isAudit ? "Close Audit" : "View Audit"}</MenuItem>
                )}
              <MenuItem onClick={() => history.push("/next/" + optimized?.dataset?.id + "/" + nextId)}>
                {"View Report"}
              </MenuItem>
              {isEnabled("sku-switcher") && (
                <MenuItem onClick={() => history.push("/business/" + id)}>{"View Business"}</MenuItem>
              )}
              {isEnabled("sku-switcher") && (
                <MenuItem
                  onClick={() => {
                    updateProjectId(isNaN(id) ? undefined : id);
                    history.push("/collaborate/");
                  }}
                >
                  {"View Collaborate"}
                </MenuItem>
              )}
            </DropdownButton>
          )}
          <CollaboratorsContainer id={id} />
        </div>
      </div>
    );
  }
}
